require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/from.js
// module id = 48
// module chunks = 0